import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Synopsis`}</h3>
    <p>{`An npm command that lets you create a task in the `}<inlineCode parentName="p">{`scripts`}</inlineCode>{` section of the `}<inlineCode parentName="p">{`package.json`}</inlineCode>{`.`}</p>
    <p>{`Deprecated.`}</p>
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/set-script.js */
    }
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm set-script [<script>] [<command>]
`}</code></pre>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/set-script.js */
    }
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS END */
    }
    <p><strong parentName="p">{`Example:`}</strong></p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`npm set-script start "http-server ."`}</inlineCode></li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "name": "my-project",
  "scripts": {
    "start": "http-server .",
    "test": "some existing value"
  }
}
`}</code></pre>
    <h3>{`Configuration`}</h3>
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`workspace`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default:`}</li>
      <li parentName="ul">{`Type: String (can be set multiple times)`}</li>
    </ul>
    <p>{`Enable running a command in the context of the configured workspaces of the
current project while filtering by running only the workspaces defined by
this configuration option.`}</p>
    <p>{`Valid values for the `}<inlineCode parentName="p">{`workspace`}</inlineCode>{` config are either:`}</p>
    <ul>
      <li parentName="ul">{`Workspace names`}</li>
      <li parentName="ul">{`Path to a workspace directory`}</li>
      <li parentName="ul">{`Path to a parent workspace directory (will result in selecting all
workspaces within that folder)`}</li>
    </ul>
    <p>{`When set for the `}<inlineCode parentName="p">{`npm init`}</inlineCode>{` command, this may be set to the folder of a
workspace which does not yet exist, to create the folder and set it up as a
brand new workspace within the project.`}</p>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`workspaces`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: null`}</li>
      <li parentName="ul">{`Type: null or Boolean`}</li>
    </ul>
    <p>{`Set to true to run the command in the context of `}<strong parentName="p">{`all`}</strong>{` configured
workspaces.`}</p>
    <p>{`Explicitly setting this to false will cause commands like `}<inlineCode parentName="p">{`install`}</inlineCode>{` to
ignore workspaces altogether. When not set explicitly:`}</p>
    <ul>
      <li parentName="ul">{`Commands that operate on the `}<inlineCode parentName="li">{`node_modules`}</inlineCode>{` tree (install, update, etc.)
will link workspaces into the `}<inlineCode parentName="li">{`node_modules`}</inlineCode>{` folder. - Commands that do
other things (test, exec, publish, etc.) will operate on the root project,
`}<em parentName="li">{`unless`}</em>{` one or more workspaces are specified in the `}<inlineCode parentName="li">{`workspace`}</inlineCode>{` config.`}</li>
    </ul>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`include-workspace-root`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Include the workspace root when workspaces are enabled for a command.`}</p>
    <p>{`When false, specifying individual workspaces via the `}<inlineCode parentName="p">{`workspace`}</inlineCode>{` config, or
all workspaces via the `}<inlineCode parentName="p">{`workspaces`}</inlineCode>{` flag, will cause npm to operate only on
the specified workspaces, and not on the root project.`}</p>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS END */
    }
    <h3>{`See Also`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-run-script"
        }}>{`npm run-script`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-install"
        }}>{`npm install`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-test"
        }}>{`npm test`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-start"
        }}>{`npm start`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      